import { render, staticRenderFns } from "./ComplaintsTableSolip.vue?vue&type=template&id=28ec76c3"
import script from "./ComplaintsTableSolip.vue?vue&type=script&lang=js"
export * from "./ComplaintsTableSolip.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsTableSolip.vue?vue&type=style&index=0&id=28ec76c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports